import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "cb87f101-4d76-4ce8-88b7-d40faed67c88", content: "2 – 3", options: {} },
  { id: "c3a3f1df-9e37-46c9-bf49-6441de4a1710", content: "2 – 4", options: {} },
  { id: "8904b11a-5ae7-4017-a3f8-2f1e66bb98a7", content: "8 – 6", options: {} },
  { id: "a383065f-6423-49b3-b9d0-e6ee06a9dddf", content: "1 – 5", options: {} },
  { id: "4e53fa3d-0089-484b-80c8-75ae369a31cf", content: "8 – 2", options: {} },
  { id: "a7b7d8f9-4225-4a42-8174-8cb0d8d80d67", content: "3 – 7", options: {} },
];

export const task: Task = {
  id: "ef1a8ea4-36d1-4aea-b935-27e27ff644e1",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "c3a3f1df-9e37-46c9-bf49-6441de4a1710",
    "8904b11a-5ae7-4017-a3f8-2f1e66bb98a7",
    "a383065f-6423-49b3-b9d0-e6ee06a9dddf",
  ],
};
